import React from "react";
import { observer } from "mobx-react";
import DetailIcon from "../../../../../images/sidebar/item-details-logo.svg"; 
import { RelatedItemsService } from "../services";
import { ProductOptionWrapper } from "../styles";
import { CollapsiblePanel } from "@mindmemobile/mm-shared-global";
import RelatedItemsSection from "./RelatedItemsSection";
 

type Props = {
  realtedItemService: RelatedItemsService;
  sourceId?: string;
};

@observer
export default class MembershipRelatedItems extends React.Component<Props> {
  render() {
    return (
      <ProductOptionWrapper>
        <CollapsiblePanel
          title="Related Items "
          className="collapsed-labels donation-collapsed"
          imgSrc={DetailIcon}
          isShowInfoIcon
          collapsibleClassName="collapsed-card"
        >
          <RelatedItemsSection
            sourceId={this.props.sourceId}
            realtedItemService={this.props.realtedItemService}
          />
        </CollapsiblePanel>
      </ProductOptionWrapper>
    );
  }
}
